import { render, staticRenderFns } from "./sendRecord.vue?vue&type=template&id=fa341a64&scoped=true"
import script from "./sendRecord.vue?vue&type=script&lang=ts"
export * from "./sendRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa341a64",
  null
  
)

export default component.exports